import moment from 'moment';

export function formatDate(time) {
    return time ? moment(time).format('YYYY-MM-DD') : null;
}

export function formatMoney(v) {
    return v ? v.toLocaleString('en') : null;
}
